// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireInformationActions = require('actions/hireInformation');
const { updateConsents } = require('actions/gdprConsents');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getDebitCardHiringStatus } = require('utilities/hireCardsHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  API_CENTER,
  API_ENTERPRISE_NUMBER,
  SECOND_STEP,
  VIRTUAL_DEBIT_CARD_PRODUCT_STANDARD,
  VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE,
  VIRTUAL_DEBIT_CARD_PRODUCT_TYPE,
} = require('constants/index');
const { VIRTUAL_DEBIT_CARD_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_RESET,
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

function setAgreementCheckbox(evt) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked: evt.target.checked,
    },
  };
}

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
    },
  };
}

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardVirtualOnlyDebit.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const validateStep = step => (dispatch, getState) => {
  if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    const immCards = getState().cards;
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');

    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    dispatch(validateLoading(true));
    return APIPost({
      dispatch,
      endpoint: 'validateCardHire',
      params: {
        query: { cards: cardObj },
      },
    })
      .then(() => {
        dispatch(validateLoading(false));
    dispatch(validate(step, false));
      })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            dispatch(validate(step, true));
            dispatch(validateLoading(false));
          } else {
            dispatch(hireCardVirtualOnlyDebitFailure(''));
            dispatch(validateLoading(false));
          }
        }
      });
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }

  return dispatch(getStep(step));
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const hireCardVirtualOnlyDebitRequest = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_REQUEST,
});

const hireCardVirtualOnlyDebitSuccess = response => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_SUCCESS,
  payload: {
    response,
  },
});

const hireCardVirtualOnlyDebitFailure = errorMsg => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_FAILURE,
  payload: {
    errorMsg,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_DEBIT_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardVirtualOnlyDebit = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    query: data,
    header: {
      version: 2,
    },
  };

  dispatch(hireCardVirtualOnlyDebitRequest());

  return APIPost({
    dispatch,
    endpoint: 'hireDebitCardVirtual',
    params: requestData,
  })
    .then(response => {
      const status = getDebitCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardVirtualOnlyDebitFailure(status.errorMsg));
      } else {
        dispatch(hireCardVirtualOnlyDebitSuccess(response));
        dispatch(setTermsAndCondsInfo(VIRTUAL_DEBIT_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
      }
    })
    .catch(response => {
      const status = getDebitCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardVirtualOnlyDebitFailure(status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardVirtualOnlyDebitFailure(''));
      } else {
        throw response;
      }
    });
};

const hireCardVirtualOnlyDebit = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardVirtualOnlyDebit.getIn([
      'steps',
      SECOND_STEP,
      'accountId',
    ]);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const data = {
      cardDetails: {
        cuentaCargo: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immAccount.get(
          'product'
        )}${immAccount.get('contractNumber')}`,
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
      },
      deliverToProvidedDetails: false,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: VIRTUAL_DEBIT_CARD_PRODUCT_STANDARD,
        subType: VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE,
        type: VIRTUAL_DEBIT_CARD_PRODUCT_TYPE,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardVirtualOnlyDebit(dispatch, data, termsAndsCondsHiringData))
      .catch(response => {
        if (!!response.error) {
          setCardVirtualOnlyDebit(dispatch, data, termsAndsCondsHiringData);
        } else {
          throw response;
        }
      });
  };

  return Promise.resolve().then(function () {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  hireCardVirtualOnlyDebit,
  reset,
  setAccount,
  setAllAccountsToInactive,
  setAgreementCheckbox,
  setVisibleStep,
  setWillCancel,
  validateStep,
};
